class GameDragAndDrop {
    /**
     * Construct
     * @param gameDragAndDrop
     */
    constructor(gameDragAndDrop) {
        /**
         * @type {Element}
         */
        this.game = gameDragAndDrop;
        /**
         * @type {NodeListOf<HTMLElementTagNameMap[[string]]> | NodeListOf<Element> | NodeListOf<SVGElementTagNameMap[[string]]>}
         */
        this.dragItems = this.game.querySelectorAll('[draggable]');
        /**
         * @type {NodeListOf<Element>}
         */
        this.dropArea = this.game.querySelectorAll('.area-drop');
        /**
         * @type {HTMLElement}
         */
        this.dropAnswer = document.getElementById('area-drop-answer');
        /**
         * @type {HTMLElement}
         */
        this.dropReply = document.getElementById('area-drop-reply');
        /**
         * @type {Element}
         */
        this.placeHolder = this.dropReply.getElementsByClassName('placeholder')[0];
        /**
         * @type {Element}
         */
        this.inputNo = this.game.querySelector('[data-disabled-secondary-question]') || this.game.querySelector('input');
        /**
         * @type {boolean}
         */
        this.isMobile = Helper.isMobileClient();
        /**
         * Init
         */
        this._init();
    }

    /**
     * Init
     * @private
     */
    _init() {
        // Set fixed height to drop answer
        this.dropAnswer.style.height = this.dropAnswer.offsetHeight + 'px';
        //set Text
        this._setDragItemPosition();
        // Set position if user already reply
        GameDragAndDrop._setTextValue(this.dropReply);
        // Add all game drag and drop listener
        this._addListener();
        // Set first reply to false if empty reply
        if (!this.dropReply.querySelector('[draggable]')) {
            this.inputNo.value = '1';
        }
        Game.setStateSecondaryQuestion();
    }

    /**
     * Add listener
     * @private
     */
    _addListener() {
        // If mobile
        if (this.isMobile) {
            Helper.loadScript('/theme/cnosf/asset/vendor/js/draggabilly.pkgd.min.js').then(() => this._mobileListener());
        } else {
            // Add listener
            for (let i = 0; i < this.dropArea.length; i++) {
                this.dropArea[i].addEventListener('dragover', (e) => e.preventDefault());
                this.dropArea[i].addEventListener('drop', (e) => this._drop(e));
            }
            for (let i = 0; i < this.dragItems.length; i++) {
                this.dragItems[i].addEventListener('dragstart', (e) => this._dragStart(e));
                this.dragItems[i].addEventListener('dragend', (e) => this._dragEnd(e));
            }
        }
    }

    _mobileListener() {
        // init Drag mobile
        for (let i = 0; i < this.dragItems.length; i++) {
            const DRAG_LIB = new Draggabilly(this.dragItems[i]);
            DRAG_LIB.on('dragEnd', (e, pointer) => {
                this._drop(e, this.dragItems[i], pointer);
            });
        }
    }

    /**
     * Set drag item position
     * @private
     */
    _setDragItemPosition() {
        for (let i = 0; i < this.dragItems.length; i++) {
            const GAME_DATA_ID      = this.dragItems[i].id.split('_')[1];
            const BOUND_INPUT_VALUE = document.getElementById('response_' + GAME_DATA_ID).value;

            if (BOUND_INPUT_VALUE === '1') {
                // Hide placeholder
                if (this.placeHolder.style.display !== 'none') {
                    this.placeHolder.style.display = 'none';
                }
                this.dropReply.appendChild(this.dragItems[i]);
            }
        }
    }

    /**
     * Drag start
     * @param e
     * @private
     */
    _dragStart(e) {
        // Store id element drag
        e.dataTransfer.setData("text", e.currentTarget.id);

        // Set pointer event area drop except current
        for (let i = 0; i < this.dropArea.length; i++) {
            if (e.target.closest('.area-drop').id !== this.dropArea[i].id) {
                const ELEMENT_INSIDE_DROP_AREA = this.dropArea[i].querySelectorAll('*');

                for (let j = 0; j < ELEMENT_INSIDE_DROP_AREA.length; j++) {
                    ELEMENT_INSIDE_DROP_AREA[j].style.pointerEvents = 'none';
                }
            }
        }
    }

    /**
     * Drag end
     * @param e
     * @private
     */
    _dragEnd(e) {
        const ALL_ELEMENT_INSIDE_DROP_AREA = this.game.querySelectorAll('.area-drop *');

        for (let i = 0; i < ALL_ELEMENT_INSIDE_DROP_AREA.length; i++) {
            ALL_ELEMENT_INSIDE_DROP_AREA[i].style.pointerEvents = '';
        }
    }

    /**
     * Drop
     * @param e
     * @param dragElement
     * @param pointer
     * @private
     */
    _drop(e, dragElement, pointer) {
        e.preventDefault();

        const ID_DRAG_ITEM = (this.isMobile) ? dragElement.id : e.dataTransfer.getData("text");
        const DRAG_ELEMENT = (this.isMobile) ? dragElement : document.getElementById(ID_DRAG_ITEM);
        let DROP_AREA      = null;

        if (this.isMobile) {
            DRAG_ELEMENT.style.display = 'none';
            DROP_AREA                  = document.elementFromPoint(pointer.clientX, pointer.clientY);
            DRAG_ELEMENT.style.left    = '';
            DRAG_ELEMENT.style.top     = '';
            DRAG_ELEMENT.style.display = '';
        } else {
            DROP_AREA = e.target;
        }

        // If drop area is not same the current drag item
        if (DROP_AREA.classList.contains('area-drop') && (DROP_AREA.id !== DRAG_ELEMENT.closest('.area-drop').id)) {
            const INPUT_VALUE = DROP_AREA.id === this.dropReply.id ? 1 : 0;

            // Hide placeholder
            if (this.placeHolder.style.display !== 'none') {
                this.placeHolder.style.display = 'none';
            }

            // Move element to drop area
            DROP_AREA.appendChild(DRAG_ELEMENT);

            // Bind text
            GameDragAndDrop._setTextValue(this.dropReply);

            // Bind value
            GameDragAndDrop._setInputValue(ID_DRAG_ITEM, INPUT_VALUE);

            // Set value zero reply
            if (this.dropReply.querySelector('[draggable]')) {
                this.inputNo.value = '0';
            } else {
                this.inputNo.value = '1';
            }

            // Refresh state
            Game.setStateSecondaryQuestion();
        }
    }

    /**
     * Set text value
     * @param dropReply
     * @private
     */
    static _setTextValue(dropReply) {
        const REPLY_AREA = document.getElementById('reply-text-area');
        const TEXTS      = dropReply.querySelectorAll('.drag-text');

        REPLY_AREA.innerText = '';

        if (TEXTS.length > 0) {
            for (let i = 0; i < TEXTS.length; i++) {
                const COMA = (i > 0) ? ', ' : '';
                REPLY_AREA.innerText += COMA + TEXTS[i].textContent
            }
        } else {
            REPLY_AREA.innerText = REPLY_AREA.getAttribute('data-placeholder')
        }
    }

    /**
     * Bind input value
     * @param idDragItem
     * @param value
     * @private
     */
    static _setInputValue(idDragItem, value) {
        const GAME_DATA_ID = idDragItem.split('_')[1];
        const INPUT        = document.getElementById('response_' + GAME_DATA_ID);
        INPUT.value        = value;
    }
}